import { useForm } from "react-hook-form";
import styled from "styled-components";
import SanitizeInputFunction from "../../../../Functions/SanitizeInputFunction";
import { useContext, useState } from "react";
import GreenCheck from "./img/green-check.png"
import RedCheck from "./img/red-check.png"
import NameIcon from "./img/account_circle.png"
import PasswordIcon from "./img/key.png"
import SanitizePasswordFunction from "../../../../Functions/SanitizePasswordFunction";
import { PageContext } from "../../../../Context/PageContext";
import PopUpWarning, { PopUpCaller } from "../../../../PopUpWarning/PopUpWarning";
import EmailConfirmFormulary, { GenerateValidationCodeFunction } from "../../../../EmailConfirmFormulary/EmailConfirmFormulary";
import { ApiConnectUserDeleteAccess } from "../../../../api/ServerApiConect";
import { ApiConnectLogRegister } from "../../../../api/LionsUserApiConect";
import SolicitarVip from "../SolicitarVip";
import OperationSucess from "./OperationSucess";
import UserNotLogged from "../UserNotLogged";

function DeleteRegister() {

    const {register, getValues} = useForm();
    const { user, setPopMenuContent, setDashboardPageSelection, managedAccess, setPage, setIsLogged} = useContext(PageContext)

    const [emailAvaliableCheck, setEmailAvaliableCheck] = useState();
    const [loginAvaliableCheck, setLoginAvaliableCheck] = useState();
    const [visiblePassword, setVisiblePassword] = useState("password");
    const [validPasswordIcon, setValidPasswordIcon] = useState("");
    const [validConfirmPasswordIcon, setValidConfirmPasswordIcon] = useState("");
    const [submitButtonColor, setSubmitButtonColor] = useState("rgba(112, 118, 113, 0.5)");

    const [availableSubmit, setAvailableSubmit] = useState("none");
    const [validLogin, setValidLogin] = useState(false);
    const [validEmail, setValidEmail] = useState(false);
    const [validPassword, setValidPassword] = useState(false);
    const [validConfirmPassword, setValidConfirmPassword] = useState(false);



    function checkLoginField (sanitizedLogin) {

        if(sanitizedLogin.length == 0) {
            setLoginAvaliableCheck("");
            setValidLogin(false);
            return; }

        if(sanitizedLogin.length < 6) {
            setLoginAvaliableCheck(RedCheck); 
            setValidLogin(false);
            return;
        }  
        
         if(sanitizedLogin != managedAccess.userid) {
            setLoginAvaliableCheck(RedCheck); 
            setValidLogin(false);
            return;
        }
        
        setLoginAvaliableCheck(GreenCheck); 
            setValidLogin(true);
    
    }

    function checkPasswordField () {
    
            var passContentField = getValues('userPassword')
    
            if(passContentField.length === 0 ) {
                setValidPassword(false);
                setValidPasswordIcon("")
                return;
            }

            if(passContentField.length < 6 && passContentField.length > 0 ) {
                setValidPassword(false);
                setValidPasswordIcon(RedCheck)
                return;
            }
    
            const regexMaiuscula = /["A-Z"]/;
            const regexMinuscula = /[a-z]/;
            const regexNumero = /[0-9]/;
            const regexCaractereEspecial = /[!@#$&*]/;
            
            const temMaiuscula = regexMaiuscula.test(passContentField);
            const temMinuscula = regexMinuscula.test(passContentField);
            const temNumero = regexNumero.test(passContentField);
            const temCaractereEspecial = regexCaractereEspecial.test(passContentField);
    
            if(temMaiuscula === false || temMinuscula === false || temNumero === false || temCaractereEspecial === false) {
                setValidPassword(false);
                setValidPasswordIcon(RedCheck)
                return;
            };
    
            setValidPasswordIcon(GreenCheck)
            setValidPassword(true);
        }
    
    
        function confirmationPassword (passConfirmation) {
    
            if(passConfirmation.length === 0) {
                setValidConfirmPassword(false);
                setValidConfirmPasswordIcon("");
                return;
            }
    
            if(getValues('userPassword') !== passConfirmation || passConfirmation.length < 4) {
                setValidConfirmPassword(false);
                setValidConfirmPasswordIcon(RedCheck);
                return;
            }
            setValidConfirmPassword(true);
            setValidConfirmPasswordIcon(GreenCheck);
        }

    function fieldsValidation(){

        if(validLogin === false  || validPassword === false || validConfirmPassword === false ) {
            setSubmitButtonColor("rgba(112, 118, 113, 0.5)");
            setAvailableSubmit("none");
            return;

        } else { 
            setSubmitButtonColor("rgb(158, 90, 11)");
            setAvailableSubmit("auto");
        };
        return;
        }

        async function submitDataAndDeleteAccess() {

            var negado = "Exclusão Negada! Houve algum problema com os dados inseridos. Tente novamente."
            var sucesso = "Exclusão foi concluída! Não há mais como acessar os dados..."

            let accountid = managedAccess.account_id;
            let username = getValues('userName');
            let userpass = getValues('userPassword');
            let usermail = user.userEmail;

            let result = ApiConnectUserDeleteAccess(accountid, username, userpass, usermail);
                result.then((response) => {

                    if(response.status == 403 || response.status == 401) {
                    setPage(<UserNotLogged />);
                    setIsLogged(false);
                    return;
                    }

                    if(response.data === false) {
                        PopUpCaller(negado,"rgba(191, 18, 18, 0.8)", 10000)
                    } else { 
                    ApiConnectLogRegister(user, `Excluiu o acesso: ${username} em: `);
                    setPopMenuContent(<OperationSucess />);
                    setTimeout(() => setDashboardPageSelection(<SolicitarVip />), 4000);
                }
            })
        }



    return(
        <NewAcessoContainer >
            <h1>EXCLUIR ACESSO</h1>
            <span><b>ATENÇÃO: </b>Ao deletar este acesso você perderá <b>PERMANENTEMENTE</b>, <br/>
            não sendo possível recuperá-lo no futuro,<br/>
            todos os <b>personagens, itens e DIAS VIPs</b> presentes na conta: 
            <h2>{managedAccess.userid} </h2></span>
            <spna>Só prossiga se tiver 100% de certeza do que está fazendo.</spna>

            <PopUpWarning />

                    <AcessoItemContainer>
                        <FieldDescriptionContainer>
                            <ColumItemHeaderIcon iconImg={NameIcon}/>
                            <ColumItemHeaderName>Login</ColumItemHeaderName>
                            <FieldAvaliableCheck checkImg={loginAvaliableCheck}/>
                        </FieldDescriptionContainer>
                        <Input
                            type="text"
                            size="30" 
                            pattern=".{6,23}"
                            {...register("userName", {
                                onChange: (e) => {
                                    var sanitizedInput = SanitizeInputFunction(e.target.value);
                                    e.target.value = sanitizedInput;}
                                    })}
                            onBlur={(e) => {
                                checkLoginField(e.target.value);
                                fieldsValidation()}
                            }
                            required 
                            placeholder=" minimo 6 digitos"
                            />
                    </AcessoItemContainer>


                    <AcessoItemContainer>
                        <FieldDescriptionContainer>
                            <ColumItemHeaderIcon iconImg={PasswordIcon}/>
                            <ColumItemHeaderName>Senha</ColumItemHeaderName>
                            <FieldAvaliableCheck checkImg={validPasswordIcon}/>
                        </FieldDescriptionContainer>
                        <Input
                            type={visiblePassword}
                            size="32"
                            {...register("userPassword", {
                                onChange: (e) => {
                                    var sanitizedPass = SanitizePasswordFunction(e.target.value);
                                    e.target.value = sanitizedPass;}
                            })}
                            pattern=".{6,32}"
                            placeholder=" Mínimo de 6 digitos"
                            onBlur={() => {
                                checkPasswordField();
                                fieldsValidation();
                            }}
                            required />
                    </AcessoItemContainer>

                    <AcessoItemContainer>
                        <FieldDescriptionContainer>
                            <ColumItemHeaderIcon iconImg={PasswordIcon}/>
                            <ColumItemHeaderName>Confirme</ColumItemHeaderName>
                            <FieldAvaliableCheck checkImg={validConfirmPasswordIcon}/>
                        </FieldDescriptionContainer>
                                                    
                        <Input
                        type={visiblePassword}
                        size="32"
                        pattern=".{6,32}"
                        placeholder="Confirme a Senha"
                        {...register('pass_confirmation', {
                            onChange: (event) =>
                                event.target.value = SanitizePasswordFunction(event.target.value)})
                        }
                        onBlur={(event) => {
                            confirmationPassword(event.target.value);
                            fieldsValidation();
                        }}
                        required
                        />
                    </AcessoItemContainer>


                    <ConfirmInput
                    color={submitButtonColor}
                    onClick={() => {
                        GenerateValidationCodeFunction(getValues('userName'), user.userEmail, "codeToEmail");
                        setPopMenuContent(
                        <EmailConfirmFormulary
                            ActionFunction={submitDataAndDeleteAccess}
                            userMail={user.userEmail}>
                        </EmailConfirmFormulary>
                        )
                    }
                    }
                    value="Excluir Acesso"
                    available={availableSubmit}
                    />
        </NewAcessoContainer> 
    )
}

export default DeleteRegister;


const NewAcessoContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 10px;
    width: 600px;
    margin: 5px 0;
    transition: .3s ease-in-out;
    color: black;
    border: solid 1px;
    
    box-shadow: 10px 10px 10px 0px black;
    &:hover {
    transform: translate(0px, 0px);
    //background-color: rgba(65, 102, 137, 0.8);
    //color: white;

    }

`

const AcessoItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    //border: solid 2px black;
    width: 400px;
    font-size: 18px;
    text-align: center;
    //border: solid;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`

const FieldDescriptionContainer = styled.div`
    display: flex;
    align-items: center;

`


const Input = styled.input`
    height: 30px;
    width: 200px;
    margin: 10px 0;
    border-radius: 0px;
    border: solid 0px rgba(0,0,0,.5);
    border-bottom: solid 1px rgba(0,0,0,.3);
    font-size: 16px;

`


const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin-right: 20px;
`

const ColumItemHeaderName = styled.span`
    font-weight: bold;
`

const FieldAvaliableCheck = styled.div`
    background-image: url(${props => props.checkImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 20px;
    height: 20px;
    margin-left: 20px;
    margin-right: 20px;
`

const ConfirmInput = styled.input`
    height: 50px;
    padding: 0px 5px;
    width: 200px;
    margin: 30px 0;
    border-radius: 5px;
    font-size: 14pt;
    border: none;
    background-color: ${props => props.color};
    color: white;
    transition: .3s ease-in-out;
    text-align: center;
    pointer-events: ${props => props.available};

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    scale: 1.1;
    
    }
`